import React, { useLayoutEffect, useState } from 'react';
import { Box, LinearProgress } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useRegistration } from '../context/RegistrationContext';

/**
 * Short top-of-viewport cue when the SPA route changes so navigation feels responsive
 * before heavier views or lazy chunks finish rendering.
 */
const NavigationRouteProgress: React.FC = () => {
  const location = useLocation();
  const { isLoggingOut } = useRegistration();
  const [active, setActive] = useState(false);

  useLayoutEffect(() => {
    if (isLoggingOut) {
      setActive(false);
      return undefined;
    }

    setActive(true);
    let cancelled = false;
    let nestedFrame = 0;
    const outerFrame = requestAnimationFrame(() => {
      nestedFrame = requestAnimationFrame(() => {
        if (!cancelled) {
          setActive(false);
        }
      });
    });
    return () => {
      cancelled = true;
      cancelAnimationFrame(outerFrame);
      if (nestedFrame) {
        cancelAnimationFrame(nestedFrame);
      }
    };
  }, [location.pathname, location.search, isLoggingOut]);

  if (!active) {
    return null;
  }

  return (
    <Box
      role="presentation"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.modal + 1,
        pointerEvents: 'none',
      }}
    >
      <LinearProgress color="primary" aria-label="Page transition" />
    </Box>
  );
};

export default NavigationRouteProgress;
